export default __webpack_public_path__ + "static/media/step_2_dont_1.42b95c23.jpg";